import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent, setConsent, loadGA4, trackPageView, canTrack } from '@/lib/analytics';
import { getPublicSiteSettings } from '../services/api';
import { Button } from '@/components/ui/button';

const TOUR_STATIC = ['istanbul', 'yurtici', 'yurtdisi'];

export const AnalyticsTracker = () => {
  const location = useLocation();
  const [consent, setConsentState] = useState(getConsent());
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    getPublicSiteSettings().then(res => setSettings(res.data)).catch(() => setSettings({}));
  }, []);

  useEffect(() => {
    if (!settings?.gsc_verification) return;
    let meta = document.querySelector('meta[name="google-site-verification"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'google-site-verification');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', settings.gsc_verification);
  }, [settings]);

  useEffect(() => {
    if (consent === 'granted' && settings?.ga4_measurement_id) loadGA4(settings.ga4_measurement_id);
  }, [consent, settings]);

  useEffect(() => {
    if (consent !== 'granted' || !canTrack()) return;
    const parts = location.pathname.split('/');
    const slug = parts[1] === 'turlar' && parts[2] && !TOUR_STATIC.includes(parts[2]) ? parts[2] : null;
    const timer = setTimeout(() => trackPageView(document.title, slug), 700);
    return () => clearTimeout(timer);
  }, [location.pathname, consent]);

  if (consent || location.pathname.startsWith('/admin')) return null;

  const choose = (value) => {
    setConsent(value);
    setConsentState(value);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] rounded-2xl bg-gray-900 text-white p-5 shadow-2xl" data-testid="cookie-consent-banner">
      <p className="text-sm leading-relaxed">
        Sitemizi geliştirmek için, izin verirseniz anonim ziyaret istatistikleri (çerezler) kullanıyoruz. Adınız, telefonunuz veya e-postanız asla analiz sistemine gönderilmez.
      </p>
      <div className="mt-4 flex gap-2">
        <Button onClick={() => choose('granted')} className="bg-orange-500 hover:bg-orange-600 rounded-full flex-1" data-testid="cookie-accept-button">Kabul Et</Button>
        <Button onClick={() => choose('denied')} variant="outline" className="rounded-full flex-1 bg-transparent text-white border-white/40 hover:bg-white/10 hover:text-white" data-testid="cookie-reject-button">Reddet</Button>
      </div>
    </div>
  );
};
